document.querySelectorAll('.category-grid-slider-wrap').forEach(function (wrap) {
  var list = wrap.querySelector('.category-grid-list');
  var prev = wrap.querySelector('.category-grid-arrow--prev');
  var next = wrap.querySelector('.category-grid-arrow--next');
  if (!list) return;

  function scrollByCard(direction) {
    var item = list.querySelector('.category-grid-item');
    if (!item) return;
    var styles = getComputedStyle(list);
    var gap = parseFloat(styles.columnGap || styles.gap || 0);
    var amount = item.getBoundingClientRect().width + gap;
    list.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function updateArrowState() {
    if (!prev || !next) return;
    var max = list.scrollWidth - list.clientWidth - 1;
    prev.disabled = list.scrollLeft <= 0;
    next.disabled = list.scrollLeft >= max;
  }

  if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
  if (next) next.addEventListener('click', function () { scrollByCard(1); });

  list.addEventListener('scroll', updateArrowState);
  window.addEventListener('resize', updateArrowState);
  updateArrowState();
});
